import styled from 'styled-components';

export const InteractiveMapStyleWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
